import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;

  > form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`

export const Input = styled.div`
  display: block;
`
